import React, { Component } from 'react'
import cs from 'classnames';
import css from './index.css';
import { timeFormat, formatTimeTz } from '~/pages/MessagePush/uilts';
import accounting from '~/misc/accounting';
import get from "lodash/get"
export const BrokerMessageLoads = (props) => {
  const {time, origin, dest, pickup, delivery, rate, price , deleteMessage, goto} = props;
  return (
    <div className={css.warp}>
      <div className={css.timeRow}>
        <div className={css.timeBlock}>
          <div className={css.time}>{timeFormat(time)}</div>
          <div className={css.brokerMessageLoadsNewOffer}>New Offer!</div>
        </div>
        <div className={css.deleteBtn} onClick={(e)=> {e.stopPropagation();deleteMessage()}}></div>
      </div>
      <div className={css.box} onClick={goto}>
        <div className={css.titleRow}>
          <div className={css.title}>
            <div className={css.brokerMessageLoadsTitle}>
              {origin}
              <div className={css.brokerMessageLoadsArrow}></div>
              {dest}
            </div>
          </div>
          <div className={css.nextIcon}></div>
        </div>
        <div className={css.contentRow}>
          <div className={css.brokerMessageLoadsContent}>
            <div className={css.brokerMessageLoadsInfo}>
              <div className={css.brokerMessageLoadsInfoLabel}>PICK UP DATE</div>
              <div className={css.brokerMessageLoadsInfoLabel}>DELIVERY DATE</div>
              <div className={css.brokerMessageLoadsInfoLabel}>RATE</div>
              <div className={css.brokerMessageLoadsInfoValue}>{timeFormat(pickup)}</div>
              <div className={css.brokerMessageLoadsInfoValue}>{timeFormat(delivery)}</div>
              <div className={css.brokerMessageLoadsInfoValue}>${rate}/mile</div>
            </div>
            <div className={css.brokerMessageLoadsPrice}>{accounting.formatMoney(price)}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const BrokerMessage = (props) => {
  const {title, message, time , deleteMessage} = props;
  return (
    <div className={css.warp}>
      <div className={css.timeRow}>
        <div className={css.time}>{timeFormat(time)}</div>
        <div className={css.deleteBtn} onClick={(e)=> {e.stopPropagation();deleteMessage()}}></div>
      </div>
      <div className={css.box}>
        <div className={css.titleRow}>
          <div className={css.title}>
            {title}
          </div>
        </div>
        <div className={css.contentRow}>
          <div className={css.brokerMessageContent}>
            {message}
          </div>
        </div>
      </div>
    </div>
  )
}

export const BidMessage = (props) => {
  const {time, title, content, goto , deleteMessage} = props
  return (
    <div className={css.warp}>
      <div className={css.timeRow}>
        <div className={css.time}>{timeFormat(time)}</div>
        <div className={css.deleteBtn} onClick={(e)=> {e.stopPropagation();deleteMessage()}}></div>
      </div>
      <div className={css.box} onClick={goto}>
        <div className={css.titleRow}>
          <div className={css.title}>
            {title}
          </div>
          <div className={css.nextIcon}></div>
        </div>
        <div className={css.contentRow}>
          <div className={css.brokerMessageContent}>
            {content} 
          </div>
        </div>
      </div>
    </div>
  )
}

export const BidAwardMessage = (props) => {
  const {time, title, content = '', goto , deleteMessage} = props;
  const [message , expireTime] = (content.match(/\<.*?\>(.*?)\<.*?\>/g) || ['','']).map(str=> str.replace(/\<.*?\>/g, ""));


  return (
    <div className={css.warp}>
      <div className={css.timeRow}>
        <div className={css.time}>{timeFormat(time)}</div>
        <div className={css.deleteBtn} onClick={(e)=> {e.stopPropagation();deleteMessage()}}></div>
      </div>
      <div className={css.box} onClick={goto}>
        <div className={css.titleRow}>
          <div className={css.title}>
            {title}
          </div>
          <div className={css.nextIcon}></div>
        </div>
        <div className={css.contentRow}>
          <div className={css.brokerMessageContent}>
            {message}
            <span className={css.bidMessageWarning}>{expireTime}</span>
          </div>
        </div>
        <div className={css.btnRow}>
          <div className={cs(css.btn, css.btnGreen)} onClick={(e)=>{e.stopPropagation();goto()}}>Go Accept Offer</div>
        </div>
      </div>
    </div>
  )
}

export const BidExpiredMessage = (props) => {
  const {time, title, content, goto , deleteMessage} = props;
  
  return (
    <div className={css.warp}>
      <div className={css.timeRow}>
        <div className={css.time}>{timeFormat(time)}</div>
        <div className={css.deleteBtn} onClick={(e)=> {e.stopPropagation();deleteMessage()}}></div>
      </div>
      <div className={css.box} onClick={goto}>
        <div className={css.titleRow}>
          <div className={css.title}>
            {title}
          </div>
          <div className={css.nextIcon}></div>
        </div>
        <div className={css.contentRow}>
          <div className={css.brokerMessageContent}>
            {content}
          </div>
        </div>
        <div className={css.btnRow}>
          <div className={css.btn} onClick={(e)=>{e.stopPropagation();goto()}}>Go Re-offer</div>
        </div>
      </div>
    </div>
  )
}


export const CarrierVerification = (props) => {
  const {time, title, content, goto, deleteMessage} = props
  return (
    <div className={css.warp}>
      <div className={css.timeRow}>
        <div className={css.time}>{timeFormat(time)}</div>
        <div className={css.deleteBtn} onClick={(e)=> {e.stopPropagation();deleteMessage()}}></div>
      </div>
      <div className={css.box} onClick={goto}>
        <div className={css.titleRow}>
          <div className={css.title}>
            {title}
          </div>
          <div className={css.nextIcon}></div>
        </div>
        <div className={css.contentRow}>
          <div className={css.brokerMessageContent}>
            {content} 
          </div>
        </div>
      </div>
    </div>
  )
}

export const BookingRequestAccept = (props) => {
  const {time, title, content, params,showRC, goto , deleteMessage} = props;
  const { status,  rcUrls} = params;
  
  return (
    <div className={css.warp}>
      <div className={css.timeRow}>
        <div className={css.time}>{timeFormat(time)}</div>
        <div className={css.deleteBtn} onClick={(e)=> {e.stopPropagation();deleteMessage()}}></div>
      </div>
      <div className={css.box} onClick={goto}>
        <div className={css.titleRow}>
          <div className={css.title}>
            {title}
          </div>
          <div className={css.nextIcon}></div>
        </div>
        <div className={css.contentRow}>
          <div className={css.brokerMessageContent}>
            {content}
          </div>
        </div>
        {
          status === 'rc' && 
          <div className={css.btnRow}>
            <div className={css.btn} onClick={(e)=>{e.stopPropagation();showRC(rcUrls)}}>View RC</div>
          </div>
        }
      </div>
    </div>
  )
}

export const TrackingInfo = (props) => {
  const {time, title, content , deleteMessage} = props
  const {from, fromDate, fromDateZone, to, toDate, toDateZone, brokerName} = content;
  return (
    <div className={css.warp}>
      <div className={css.timeRow}>
        <div className={css.time}>{timeFormat(time)}</div>
        <div className={css.deleteBtn} onClick={(e)=> {e.stopPropagation();deleteMessage()}}></div>
      </div>
      <div className={css.box}>
        <div className={css.titleRow}>
          <div className={css.title}>
            {title}
          </div>
        </div>
        <div className={css.contentRow}>
          <div className={css.trackingContent}>
            <div className={css.trackingTime}>
              <div className={css.timeIcon}></div>
              {formatTimeTz(fromDate, 'MMM DD', fromDateZone)} · {formatTimeTz(toDate, 'MMM DD', toDateZone)}
            </div>
            <div className={css.trackingLocation}>
              <div className={css.originIcon}></div>
              {from}
            </div>
            <div className={css.trackingLocation}>
              <div className={css.destIcon}></div>
              {to}
            </div>
            <div className={css.trackingSender}>
              by {brokerName}
            </div>
            <div className={css.tracingPhoneCheckHint}>
              Please check details & update tracking in Truckloads App
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/pages/MessagePush/compontents/MessagePanel/compontents/MessageCard/index.js